import React from 'react';
import classnames from 'classnames';
import EllipsisLineClampText from '@sg/components/EllipsisLineClampText';
import {
  formatCompactDateString,
} from '@sg/utils/common';
import './index.scss';

interface ICurrentMilestone {
  category?: string;
  name?: string;
  due?: string;
  date_confirm?: number;
}

interface IProps {
  milestone?: ICurrentMilestone;
  withDivider?: boolean;
}

const CLS = 'dbs-idp-milestone';

const formatDueDate = (due?: string, dateConfirm?: number): string => {
  if (!due) {
    return '-';
  }
  const dueStr = String(due).trim();
  // Compact date string from API, e.g. 20260205 / 202602.
  if (/^\d{6}(\d{2})?$/.test(dueStr)) {
    return formatCompactDateString(dueStr, dateConfirm);
  }
  return dueStr;
};

const MilestoneCell: React.FC<IProps> = ({
  milestone,
  withDivider = false,
}) => {
  const name = milestone?.name || '-';
  const due = formatDueDate(milestone?.due, milestone?.date_confirm);

  return (
    <div
      className={classnames(
        CLS,
        withDivider && `${CLS}--with-divider`,
      )}
    >
      <div className={`${CLS}__header`}>Current Milestone</div>
      <div className={`${CLS}__body`}>
        <EllipsisLineClampText text={name} className={`${CLS}__name`} lineClamp={2} placement="top" />
        <div className={`${CLS}__due-wrapper`}>
          <span className={`${CLS}__due-label`}>DUE</span>
          <span className={`${CLS}__due-value`}>{due}</span>
        </div>
      </div>
    </div>
  );
};

export default MilestoneCell;

